'use client';

import React from 'react';
import SlideWrapper from '../SlideWrapper';
import { Utensils, Package, Anchor } from 'lucide-react';

interface Props {
  id: string;
  registerRef: (id: string, el: HTMLElement | null) => void;
}

const activities = [
{
  icon: <Utensils size={18} className="text-[#e8a030]" />,
  time: '07:00 – 08:00',
  title: 'Ăn sáng',
  desc: 'Bữa sáng cuối cùng trên đảo, tận hưởng khoảnh khắc bình yên trước khi chia tay.',
  accent: '#e8a030'
},
{
  icon: <Package size={18} className="text-[#4caf7d]" />,
  time: '08:00 – 09:00',
  title: 'Chuẩn bị hành lý',
  desc: 'Thu dọn đồ đạc, dọn dẹp khu vực ở, chuẩn bị cho chuyến về.',
  accent: '#4caf7d'
},
{
  icon: <Anchor size={18} className="text-[#f5c96a]" />,
  time: '09:10',
  title: 'Lên thuyền – về đất liền – kết thúc hành trình',
  desc: 'Lên thuyền rời đảo, kết thúc hành trình 8 ngày 7 đêm đầy ý nghĩa tại Hồ Trị An.',
  accent: '#f5c96a'
}];


export default function Slide12gDay8({ id, registerRef }: Props) {
  return (
    <SlideWrapper id={id} registerRef={registerRef} className="bg-[#0a1a0f]">
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1641966922465-21132d3da533"
          alt="Thuyền gỗ truyền thống trên mặt hồ Trị An yên bình, bầu trời xanh và núi non phản chiếu trên mặt nước"
          className="w-full h-full object-cover opacity-12" />
        
        <div className="absolute inset-0 bg-gradient-to-br from-[#0a1a0f]/80 via-[#1a3a2a]/50 to-[#0a1a0f]" />
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[rgba(245,201,106,0.5)] to-transparent" />
      </div>

      <div className="relative z-10 max-w-screen-xl mx-auto px-6 lg:px-16 xl:px-24 py-24 pt-28 min-h-screen flex flex-col justify-center">
        <div className="fade-in-up mb-4">
          <div className="chapter-badge amber">
            <span className="w-1.5 h-1.5 rounded-full bg-[#f5c96a] inline-block" />
            Hành trình 8 ngày 7 đêm
          </div>
        </div>

        <div className="fade-in-up mb-3">
          <h2 className="font-display font-800 text-[clamp(24px,3.5vw,48px)] leading-[1.1] text-[#f0ede6] tracking-tight">
            NGÀY 8
          </h2>
          <h2 className="font-display font-800 text-[clamp(18px,2.5vw,32px)] leading-[1.3] tracking-tight text-gradient-amber">
            Lên thuyền – Về đất liền – Kết thúc hành trình
          </h2>
        </div>

        <div className="fade-in-up mb-8">
          <div className="w-[60px] h-[3px] bg-gradient-to-r from-[#e8a030] to-[#f5c96a] rounded-full" />
        </div>

        <div className="relative fade-in-up">
          <div className="absolute left-[22px] top-0 bottom-0 w-px bg-gradient-to-b from-[#f5c96a]/60 to-transparent" />
          <div className="flex flex-col gap-5">
            {activities.map((act, i) =>
            <div key={`d8-${i}`} className="flex items-start gap-4 pl-2">
                <div
                className="flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center z-10"
                style={{ background: `${act.accent}22`, border: `1.5px solid ${act.accent}55` }}>
                
                  {act.icon}
                </div>
                <div
                className="flex-1 rounded-xl p-5 transition-all duration-300 hover:-translate-y-0.5"
                style={{ background: `${act.accent}0d`, border: `1px solid ${act.accent}22` }}>
                
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span
                    className="font-body font-700 text-[11px] tabular-nums px-2 py-0.5 rounded-full"
                    style={{ color: act.accent, background: `${act.accent}18` }}>
                    
                      {act.time}
                    </span>
                    <h3 className="font-display font-700 text-[15px] lg:text-[17px] text-[#f0ede6]">
                      {act.title}
                    </h3>
                  </div>
                  <p className="font-body text-[13px] lg:text-[14px] text-[#a0b8a8] leading-relaxed">
                    {act.desc}
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="fade-in-up mt-10 glass-card p-6 text-center">
          <p className="font-display font-700 text-[18px] lg:text-[22px] text-[#f0ede6] mb-2">
            Hành trình <span className="text-gradient-amber">8 ngày 7 đêm</span> kết thúc
          </p>
          <p className="font-body text-[14px] text-[#a0b8a8] leading-relaxed">
            Những gì các bạn xây dựng, trồng trọt và để lại — sẽ tiếp tục sống mãi tại Hồ Trị An.
          </p>
        </div>
      </div>
    </SlideWrapper>);

}